import { createContext } from 'react'
import { useQueryNext } from './hooksF/useQueryNextF.js'
import { ErrLoadingWrap } from './ErrLoadingF.jsx'
import { gql } from '@apollo/client'
const GetPubEnvQuery = gql`query($gqNonce: String!) {
  gqPubEnv(gqNonce: $gqNonce)
}`

export const PubEnvCtx = createContext(/** @type {Record<string, any> | undefined} */ (undefined))

export const PubEnvWrapper = ({
  children, isQuiet=false
}) => {
  const gqNonce = process.env.NEXT_PUBLIC_GIT_SHA
  const {data, loading, error} = useQueryNext(GetPubEnvQuery, {variables: {
    gqNonce
  }})

  const ret = <PubEnvCtx.Provider {...{value: data?.gqPubEnv, children}} />

  if (isQuiet) return ret

  return <ErrLoadingWrap {...{loading, error}}>{ret}</ErrLoadingWrap>
}